import React from 'react';
import { Link } from 'react-router-dom';
import './Home.css';

const Home = () => {
  return (
    <div className="home">
      <main className="home-main">
        <div className="hero-section">
          <div className="coming-soon">
            <h2>Coming Soon</h2>
          </div>
          <div className="cta-buttons">
            <Link to="/privacy" className="cta-button secondary">Privacy Policy</Link>
            <Link to="/contact" className="cta-button secondary">Contact Support</Link>
          </div>
        </div>
      </main>
    </div>
  );
};

export default Home;
